import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function ChartDescription({ title, percent, color, current }) {
  const { t } = useTranslation();
  return (
    <S.ChartDescriptionArea>
      <S.DotDescription color={color}>{title}</S.DotDescription>
      <S.DescriptionPercentArea>
        <b>{percent || 0}</b>
        <S.RecipientCount>{t('countRecipients', { count: current || 0 })}</S.RecipientCount>
      </S.DescriptionPercentArea>
    </S.ChartDescriptionArea>
  );
}

export { ChartDescription };
